import classNames from "classnames";
import { useQuery } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-light-svg-icons";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import styled, { css } from "styled-components";

import { Hovercard } from "common/components/hovercard";
import { Placeholder } from "common/components/placeholder";

import "merchant/features/analytics/style/_summary-bar.scss";

export function SummaryBar({
    summaries,
    section,
    toggleDetails = true,
    queryKey,
    queryFn,
    
    queryDeps,
    TOGGLE_DETAILS
}) {
    const { data, status } = useQuery([queryKey, queryDeps], queryFn);
    
    const detailsToggle = toggleDetails && <ShowHideToggle show={section === "details"} TOGGLE={TOGGLE_DETAILS} />;

    return (
        <SummaryBarWrapper>
            {summaries.map((summary, i) => (
                <div key={summary.dataField} className={classNames(`col-md-${summary.size}`, { context: i === 0, "data-regular": i !== 0 })}>
                    <div className="wrap">
                        {i === 0 && <><SummaryBlock {...summary} status={status} blockData={data?.[summary.dataField]} />{detailsToggle}</>}
                        {i > 0 && <div className="summary-block"><SummaryBlock {...summary} status={status} blockData={data?.[summary.dataField]} /></div>}
                    </div>
                </div>
            ))}
        </SummaryBarWrapper>
    );
}

function SummaryBlock({
    title, description, blockData, status, formatter
}) {
    return (
        <>
            <div className="block-name">
                {
                description
                    ? <Hovercard header={title} body={description}><span>{title} <FontAwesomeIcon icon={faQuestionCircle} /></span></Hovercard>
                    : <span>{title}</span>
            }
            </div>
            <div className="block-value primary has-loader only" data-loader-height="25">
                {status === "loading" ? <Placeholder size="medium" noMargin /> : <Value value={blockData} formatter={formatter} />}
            </div>
        </>
    );
}

const StyledToggleWrapper = styled.div`
    padding: 2px 7px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    font-family: ${({ theme }) => theme.text.regular};
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    background: rgba(0, 0, 0, 0.1);
    width: 100%;

    ${({ show }) => show && css`
        background: #fff;
        color: ${({ theme }) => theme.colors["paz-black"]};
        left: 0;
    `}
    &:hover {
        background: ${({ show }) => (show ? "rgba(255, 255, 255, 0.9)" : "rgba(0, 0, 0, 0.2)")};
    }
`;

/**
 * A component to toggle between show and hide states.
 */
export function ShowHideToggle({
    show,
    TOGGLE,
    title = "details",
    className = ""
}) {
    return (
        <StyledToggleWrapper className={className} show={show} onClick={TOGGLE}>
            <FontAwesomeIcon icon={faList} aria-hidden="true"/> {show ? "Hide" : "View"} {title}
        </StyledToggleWrapper>
    );
}

/**
 * A Value represents a number as a string via the provided formatter, or "-" if a non-finite value is passed.
 */
export const Value = ({
    value,
    formatter = (v) => v
}) => {
    if (!Number.isFinite(value)) {
        return "-";
    }
    return formatter(value);
};

export function SummaryBarWrapper({ children }) {
    return (
        <div className="summary-bar">
            <div className="row wrap">
                {children}
            </div>
        </div>
    );
}
